<template>
  <div
    class="lpu-card-skeleton"
    data-qa="lpu_card_skeleton"
  >
    <v-skeleton-loader
      class="lpu-card-skeleton__profile"
      type="avatar,article"
    />
    <div class="lpu-card-skeleton__contact-list">
      <v-skeleton-loader
        v-for="i in 5"
        :key="i"
        type="text@3"
      />
    </div>
    <v-skeleton-loader
      class="lpu-card-skeleton__select"
      type="text"
    />
    <v-skeleton-loader
      class="lpu-card-skeleton__calendar-title"
      type="text@3"
    />
    <v-skeleton-loader
      class="lpu-card-skeleton__calendar"
      type="text@4"
    />
    <v-skeleton-loader
      class="lpu-card-skeleton__description"
      type="text@4"
    />
  </div>
</template>

<script>
export default {
  name: 'ClinicCardSkeleton',
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.lpu-card-skeleton {
  padding: 16px;
  border-radius: $border-radius-md;
  border: 1px solid $color-ultra-deep-grey;
  background-color: $ui-kit-bg-gray-0;
  box-shadow: 0 15px 20px rgba(151, 158, 167, 0.1);

  $sk: v-skeleton-loader;

  &__profile {
    &.v-skeleton-loader {
      display: flex;
      justify-content: center;
      position: relative;
      overflow: initial;
    }

    .v-skeleton-loader__avatar {
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 2;
      width: 32px;
      height: 32px;
    }

    .v-skeleton-loader__heading {
      width: 240px;
      height: 80px;
      margin: 0 0 8px !important;
    }

    .v-skeleton-loader__paragraph {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 !important;

      .v-skeleton-loader__text {
        width: 216px;
        height: 24px;
        margin-bottom: 8px;
      }

      .v-skeleton-loader__text:first-child {
        width: 216px;
        height: 32px;
        margin-bottom: 12px;
      }

      .v-skeleton-loader__text:last-child {
        width: 114px;
        height: 20px;
        margin-bottom: 28px;
      }
    }
  }

  &__contact-list {
    margin-bottom: 24px;

    .v-skeleton-loader {
      display: flex;

      &:not(:last-child) {
        margin-bottom: 24px;
      }

      /* stylelint-disable-next-line no-descending-specificity */
      .v-skeleton-loader__text {
        flex-grow: 0;
        width: 45%;
        height: 24px;
        margin-bottom: 0;
      }

      .v-skeleton-loader__text:first-child {
        width: 24px;
        margin-right: 16px;
      }

      .v-skeleton-loader__text:last-child {
        width: 24px;
        margin-left: auto;
      }
    }
  }

  &__select {
    /* stylelint-disable-next-line no-descending-specificity */
    .v-skeleton-loader__text {
      height: 48px;
      margin-bottom: 16px;
    }
  }

  &__calendar-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    /* stylelint-disable-next-line no-descending-specificity */
    .v-skeleton-loader__text {
      flex-grow: 0;
      width: 45%;
      height: 24px;
      margin-bottom: 16px;
    }

    /* stylelint-disable no-descending-specificity */
    .v-skeleton-loader__text:first-child,
    .v-skeleton-loader__text:last-child {
      width: 32px;
      height: 32px;
      border-radius: $border-radius-circle;
    }
    /* stylelint-enable no-descending-specificity */
  }

  &__calendar {
    display: flex;
    justify-content: space-between;

    /* stylelint-disable-next-line no-descending-specificity */
    .v-skeleton-loader__text {
      flex-grow: 0;
      width: 23%;
      height: 40px;
      margin-bottom: 16px;
    }
  }

  &__description {
    /* stylelint-disable-next-line no-descending-specificity */
    .v-skeleton-loader__text {
      height: 14px;
      margin-bottom: 8px;
    }

    /* stylelint-disable-next-line no-descending-specificity */
    .v-skeleton-loader__text:last-child {
      flex-grow: 0;
      width: 63%;
    }
  }
}
</style>
